import React from "react";
import { Link } from "gatsby";
import BookTemplate from "./book-template";
var ArticleAuthorInfo = function ArticleAuthorInfo(_ref) {
    var authors = _ref.authors, book = _ref.book;
    // @ts-ignore
    var showAuthorBox = authors && authors.length > 0 && authors.some(function (a) {
        return a.shortDescription || a.description;
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: showAuthorBox ? "makro-grey border-t-8 border-solid border-makroOrange pt-2 lg:absolute lg:inset-x-0 lg:-mr-12" : ""
    }, authors.map(function (author, index) {
        // @ts-ignore
        var description = author.shortDescription ? author.shortDescription : author.description;
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: "contents"
        }, /*#__PURE__*/ React.createElement(Link, {
            to: "/autoren/" + author.slug + "/artikel/",
            className: "block mb-4 text-sm"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "break-words",
            style: {
                hyphens: "auto"
            },
            dangerouslySetInnerHTML: {
                __html: description
            }
        })));
    }), /*#__PURE__*/ React.createElement(BookTemplate, {
        book: book
    }));
};
export default ArticleAuthorInfo;
